import clsx from 'clsx';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './Infobox.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IInfoboxBlockFields } from 'types/contentful/generated';
import type { Document } from '@contentful/rich-text-types';

type Props = IInfoboxBlockFields & {
  textContent?: Document;
  inspectorProps?: InspectorPropsType;
};

const Infobox = ({
  blockId,
  theme,
  title,
  textContent,
  inspectorProps,
}: Props): JSX.Element => (
  <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
    <div
      className={clsx(
        styles.content,
        title ? styles.contentWithTitle : styles.contentWithoutTitle,
        theme === 'default' ? styles.default : styles.light,
      )}
    >
      {title && <p className={styles.title}>{title}</p>}
      <RichText
        fields={textContent}
        inspectorProps={{ ...inspectorProps?.({ fieldId: 'textContent' }) }}
      />
    </div>
  </div>
);

export default Infobox;
